import { render, staticRenderFns } from "./ModalApproveWhatsapp.vue?vue&type=template&id=2a373d60&"
import script from "./ModalApproveWhatsapp.vue?vue&type=script&lang=ts&"
export * from "./ModalApproveWhatsapp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports